import { PatientHealthIndicators } from "./PatientHealthIndicators";

interface PatientIndicadoresProps {
  patientId: string;
  patientCpf: string;
  pdfExportRef?: React.MutableRefObject<{ exportPDF: () => void } | null>;
}

export function PatientIndicadores({
  patientId,
  patientCpf,
  pdfExportRef,
}: PatientIndicadoresProps) {
  return (
    <div className="space-y-6 w-full max-w-full overflow-x-hidden">
      {/* Indicadores de Saúde */}
      <PatientHealthIndicators
        patientId={patientId}
        hideHeader={true}
        pdfExportRef={pdfExportRef}
      />
    </div>
  );
}
